package pt.at.oss.kotlin.pages.i18n

import pt.at.oss.kotlin.core.i18n.I18nBase
import pt.at.oss.kotlin.core.i18n.PageLocale

enum class PaymentsListI18n(override val translations: Map<PageLocale, String>) : I18nBase {

    FORM_TITLE(
        mapOf(
            PageLocale.PT to "Consultar Pagamentos",
            PageLocale.EN to "Consult Payments"
        )

    ),

    // Table columns
    REFERENCE_COLUMN(
        mapOf(
            PageLocale.PT to "Referência",
            PageLocale.EN to "Reference"
        )
    ),
    VALOR_A_PAGAR_COLUMN(
        mapOf(
            PageLocale.PT to "Valor Declarado",
            PageLocale.EN to "Declared Amount"
        )
    ),
    VALOR_PAGO_COLUMN(
        mapOf(
            PageLocale.PT to "Valor Pago",
            PageLocale.EN to "Paid Amount"
        )
    ),
    PERIODO_COLUMN(
        mapOf(
            PageLocale.PT to "Período",
            PageLocale.EN to "Period"
        )
    ),
    SITUACAO_COLUMN(
        mapOf(
            PageLocale.PT to "Situação",
            PageLocale.EN to "Situation"
        )
    ),
    DATA_SITUACAO_COLUMN(
        mapOf(
            PageLocale.PT to "Data Situação",
            PageLocale.EN to "Situation Date"
        )
    ),
    RETURN_ACTIONS_COLUMN(
        mapOf(
            PageLocale.PT to "",
            PageLocale.EN to ""
        )
    ),

    // Row actions
    RETURN_DUC_BUTTON(
        mapOf(
            PageLocale.PT to "obter duc",
            PageLocale.EN to "get duc"
        )
    ),

    // Search form
    SELECT_IOSS_NUMBER_LABEL(
        mapOf(
            PageLocale.PT to "Número IOSS",
            PageLocale.EN to "IOSS Number"
        )
    ),
    SELECT_PERIOD_LABEL(
        mapOf(
            PageLocale.PT to "Período",
            PageLocale.EN to "Period"
        )
    ),
    SELECT_SITUACAO_LABEL(
        mapOf(
            PageLocale.PT to "Situação",
            PageLocale.EN to "Situation"
        )
    ),

    // Search buttons
    CLEAR_BTN_LABEL(mapOf(PageLocale.PT to "limpar")),
    SEARCH_BTN_LABEL(mapOf(PageLocale.PT to "pesquisar")),

    ;
}
